import { useState, useEffect } from "react";
import { FormControl, FormLabel, Input, Tag, TagLabel, TagCloseButton, Box, Tooltip, useColorModeValue } from "@chakra-ui/react";

function ChipInput({ label, placeholder, value = [], onChange }) {
    const [inputValue, setInputValue] = useState("");
    const [chips, setChips] = useState(value); 
    const placeholderColor = useColorModeValue("gray.300", "gray.400");

    useEffect(() => {
        setChips(value);
    }, [value]);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && inputValue.trim() !== "") {
            addItem(e)
        }
    };
    const addItem = (e) => {
        e.preventDefault();
        if (inputValue.trim()) {
            const newChips = [...chips, { label: inputValue.trim() }];
            setChips(newChips);
            setInputValue("");
            onChange?.(newChips);
        }
    };

    const handleRemove = (chipToRemove) => {
        const newChips = chips.filter((chip) => chip.label !== chipToRemove.label);
        setChips(newChips);
        onChange?.(newChips);
    };
    return (
        <FormControl>
            {label && (
                <FormLabel fontWeight="bold" fontSize="xs">
                    {label}
                </FormLabel>
            )}

            <Box
                bg={useColorModeValue("white", "navy.900")}
                display="flex"
                alignItems="center"
                flexWrap="wrap"
                border="1px solid"
                borderColor={useColorModeValue("gray.200", "navy.900")}
                borderRadius="md"
                p={2}
            >
                {chips.map((chip, index) => (
                    <Tooltip label={chip.label} hasArrow placement="top">
                        <Tag key={index} size="md" colorScheme="gray" borderRadius="full" m={1}>
                            <TagLabel 
                                isTruncated
                                display={'block'}
                                maxW="150px"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis">
                                    {chip.label}
                            </TagLabel>
                            <TagCloseButton onClick={() => handleRemove(chip)} />
                        </Tag>
                    </Tooltip>
                ))}

                <Input
                    flex="1"
                    variant="unstyled"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={addItem}
                    placeholder={chips.length ? "" : placeholder}
                    fontSize="sm"
                    minW="50px"
                    _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                />
            </Box>
        </FormControl>
    );
}

export default ChipInput;
